import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'

import { TSSORealm } from '../../../../types/ssoRealm'
import { updateSsoRealm, fetchSsoRealms } from '../../../../store/ssoRealms/actions'
import { fetchInstallations } from '../../../../store/installations/actions'
import { Edit } from './Edit'
import { IEditDispatchProps } from './types'
import { IStateProps } from '../types'
import { IState } from '../../../../store/types'

const mapStateToProps = (state: IState): IStateProps => {
  return {
    ssoRealms: state.ssoRealms,
    installations: state.installations
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): IEditDispatchProps => {
  return {
    fetchSsoRealms: () => {
      return dispatch(fetchSsoRealms())
    },
    fetchInstallations: () => {
      return dispatch(fetchInstallations())
    },
    updateSsoRealm: (ssoRealm: TSSORealm) => {
      return dispatch(updateSsoRealm(ssoRealm))
    }
  }
}

const EditContainer = connect(mapStateToProps, mapDispatchToProps)(Edit)

export {
  EditContainer
}
